module.exports = __webpack_public_path__ + "img/Apoptosis-OVCA_10X_TIP.d3a879f5.png";